
import moment from "moment";

/**
 * Parses non-standard date strings like "2026-01-23 11:50:19 +0000 +0000"
 * that fail in Firefox but work in Chrome
 */
export const parseDateString = (dateStr: string | null | undefined): moment.Moment | null => {
  if (!dateStr) return null;

  // Remove duplicate timezone offset: "+0000 +0000" → "+0000"
  const sanitized = dateStr
    .toString()
    .trim()
    .replace(/(\+\d{4}|\-\d{4}|UTC|Z)\s+(\+\d{4}|\-\d{4}|UTC|Z)$/, "$1");

  // Try multiple formats for broad compatibility
  const formats = [
    "YYYY-MM-DD HH:mm:ss Z",
    "YYYY-MM-DD HH:mm:ss ZZ",
    "YYYY-MM-DDTHH:mm:ssZ",
    moment.ISO_8601,
  ];

  const parsed = moment(sanitized, formats, true); // strict mode

  if (parsed.isValid()) return parsed;

  // Fallback: non-strict parsing
  const fallback = moment(sanitized);
  return fallback.isValid() ? fallback : null;
};

export const formatDate = (dateStr: string | null | undefined): string => {
  const parsed = parseDateString(dateStr);
  if (!parsed) return "—";
  return parsed.format("MMM DD, YYYY hh:mm A");
};